<div class="calendar">
    <full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>
